<template>
    <div class="col-sm-8 contact_form add-prd-item">
        <h6>Add New Item </h6>
            <form class="sp-forms-one">
                <ul class="row">
                 
                    <li class="col-md-12">
                        <label> *Product Price
                            <input type="number" v-model="product.product_item_price" value="" placeholder="" class="form-control">
                        </label>
                    </li>
                     <li class="col-md-12">
                          <label> *Product Weight
                            <input type="number" v-model="product.product_item_weight"  step="any" placeholder="" class="form-control">
                          </label>
                    </li>

                     <li class="col-md-12">
                          <label> *Product Quantity
                            <input type="number" v-model="product.product_item_quantity"  placeholder="" class="form-control">
                          </label>
                    </li>
                    
                    <li class="col-md-12">
                        <label> Product Image</label>
                        <input type="file" id="input-file" @change="onFileChange($event)" accept="image/*"/>
                    </li>

                   
                    <li class="col-md-6">
                          <button type="button" class="btn" @click="addProductItem">Add</button>
                          <!-- <button class="btn" type="button"  @click="setComponent('reset-edit','')"><i class="icon-ban"></i> Cancel</button> -->
                    </li>
                </ul>
        </form>
        
    </div>
</template>
<style>
  /*form*/
  .contact_form li {
	text-align: left;
	margin-bottom: 10px;
}
.contact_form li input {
	display: inline-block;
	width: 100%;
	height: 35px;
	padding: 0 10px;
	margin-top: 5px;
}
.contact_form li .error {
	border: 1px solid #CCC;
	border-bottom: 1px solid red;
}
.contact_form li .form-control {
	height: 45px;
	border: 1px solid #2d3a4b;
	box-shadow: none;
	border-radius: 0px;
	background: #fff;
}
.contact_form li textarea {
	height: 140px !important;
	width: 340px;
	margin-top: 10px;
}
.contact_form li .btn {
	text-transform: uppercase;
	padding: 0px 40px;
	height: 45px;
	line-height: 45px;
	font-size: 14px;
	margin-top: 15px;
}
.contact_form li .btn:hover {
	background: #ffffff;
}
.contact-form .tittle {
	text-align: center;
}
.contact-form .tittle hr {
	width: 28px;
	height: 5px;
	margin: 15px auto;
	background: #448aff;
	border: none;
}
.contact-form .tittle p {
	text-transform: none;
	font-size: 16px;
}
.contact-form label {
	font-weight: normal;
	color: #2d3a4b;
	font-size: 12px;
	text-transform: uppercase;
	display: inline-block;
	width: 100%;
	margin: 0px;
	margin-bottom: 13px;
}
.contact-form textarea {
	display: inline-block;
	width: 100%;
	position: relative;
	padding: 10px 20px;
}

</style>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'ProductItemForm',
    data () {
        return {
            user:{},
            sellpoint: {},
            product:{},
            product_items: {},
            disable_btn: false,
            imageForm: "",
            addProductItemPanel: false
        }
    },
    components: {
       
     },
    methods: {
        setComponent(attr1,attr2){
            //this.setPanel = true;
            if(attr1 == 'add-product-item'){
                this.addProductItemPanel = true;
            
            }
            if(attr1 == 'reset-edit'){
               
                //  document.getElementsByClassName('add-prd-item').style.display = 'none';
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        //get sellpoint categories
                        this.setProduct();
                    }else {
                        this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },

       setProduct(){
            service.getProductSearch(this, this.$route.params.id).then(response => {
                if(response.body.status == 200) {
                    this.product = response.body.data;
                }
            }).catch((err) => {
                //log it
                this.$router.push("/")
            })
        },

        

    addProductItem(){
        this.disable_btn = true;
        //this.business.agree = true;
        var credentials = {
            product_id: this.product.product_id,
            product_item_price: this.product.product_item_price,
            product_item_weight: this.product.product_item_weight || 1,
            product_item_quantity: this.product.product_item_quantity || 1
        }

        let navi = this.$router;
       if(credentials.product_item_price != undefined) {
            service.addProductItem(this, credentials).then(function(data) {
                if(data.body.status == 201) {
                   // toastr.success("Product Item Added Successfully", 'Success!');
                     
                    //add image
                    let result = data.body.data;
                    this.imageForm.append("data_id", result.product_item_id);
                    this.imageForm.append("data_type","product_items");
                    service.uploadDataPhoto(this, this.imageForm).then(data => {
                       if(data.body.status == 200){
                            //this.product.product_image = data.body.data;
                            location.reload(true);
                        }
                    }).catch((err) => {
                            if(err) {
                            // log it
                            }
                    })
                    
                }
            }).catch((err) => {
                if(err) {
                   // toastr.warning("Something went wrong", 'Warning!'); 
                    console.log(err)
                    this.disable_btn = false;
                }
            })
        }else {
            toastr.error('Kindly fill all fields', 'Warning!');
            this.disable_btn = false;
        }
    },

     //uploads
    onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (files.length)
        {
            let formData = new FormData();
            formData.append('photo', files[0]); 
            // formData.append('data_id', data);
            // formData.append('data_type', type);   

            this.imageForm = formData;
            // service.uploadDataPhoto(this, formData).then(data => {
            //     if(data.body.status == 200){
            //         this.product.product_image = data.body.data;
            //     }
            //     }).catch((err) => {
            //         if(err) {
            //            // log it
            //         }
            //     })
        }   
            
        },

},
    created: function(){
        //this.preset();
        this. imageForm = new FormData();
        this.setProduct();
    }
}

</script>


// WEBPACK FOOTER //
// ProductItemForm.vue?2d9e3ce0